import { Controller } from "stimulus";
import {v4} from "uuid";

export default class extends Controller {
  static get targets() {
    return ["idField"];
  }

  connect() {
    this.populateIdField();
  }

  populateIdField() {
    this.idFieldTarget.value = v4();
  }
}
